export const ALLOWED_FEEDBACK_COUNT_MEASURES = [
  'feedback-count',
  'feedback-csat',
  'feedback-nps',
  'feedback-ces',
  'feedback-weighted-score',
  'feedback-sentiment-score',
];
